/** tfa: two-factor sign-in. English + Arabic (Arabic is a draft for native review). */
const en = {
  "title": "Two-factor sign-in",
  "intro": "After your password, sign-in also asks for a 6-digit code from an authenticator app on your phone (Google Authenticator, Microsoft Authenticator, Authy, 1Password…). Someone who learns your password still can't get in.",
  "on": "On",
  "off": "Off",
  "turnOn": "Turn on",
  "scan": "Scan this code with your authenticator app, then enter the 6 digits it shows.",
  "manual": "Can't scan? Enter this key in the app:",
  "code": "6-digit code",
  "confirm": "Confirm",
  "cancel": "Cancel",
  "codesTitle": "Your recovery codes",
  "codesHint": "If you lose your phone, sign in with one of these instead of a code. Each works once. Keep them somewhere safe (a password manager); they won't be shown again.",
  "copy": "Copy",
  "download": "Download",
  "copied": "Copied",
  "saved": "I've saved them",
  "codesLeft": "{n} recovery code left | {n} recovery codes left",
  "newCodes": "New recovery codes",
  "newCodesHint": "Enter a code from your app. The old recovery codes stop working.",
  "turnOff": "Turn off",
  "turnOffHint": "Enter your password and a code from your app.",
  "password": "Password",
  "requiredBy": "Required by {orgs}, so it can't be turned off.",
  "enabled": "Two-factor sign-in is on",
  "disabled": "Two-factor sign-in is off",
  "orgTitle": "Require two-factor sign-in",
  "orgHint": "Everyone in {org} must use two-factor sign-in. People without it can only open their account settings until they turn it on.",
  "orgNeedsYours": "Turn it on for your own account first.",
  "orgOn": "Two-factor sign-in is now required for everyone",
  "orgOff": "Two-factor sign-in is now optional",
  "requiredTitle": "{org} requires two-factor sign-in",
  "requiredBody": "Set it up now to continue. It takes a minute with an authenticator app on your phone.",
  "loginCodeTitle": "Enter your code",
  "loginCodeHint": "Open your authenticator app and enter the 6-digit code. Lost your phone? Enter one of your recovery codes.",
  "loginCodeLabel": "Code or recovery code",
  "verify": "Verify",
  "backToPassword": "Use another account"
};
const ar: typeof en = {
  "title": "التحقق بخطوتين",
  "intro": "بعد كلمة المرور، يطلب تسجيل الدخول أيضًا رمزًا من 6 أرقام من تطبيق مصادقة على هاتفك (Google Authenticator أو Microsoft Authenticator أو Authy أو 1Password…). من يعرف كلمة مرورك لا يستطيع الدخول مع ذلك.",
  "on": "مفعّل",
  "off": "غير مفعّل",
  "turnOn": "تفعيل",
  "scan": "امسح هذا الرمز بتطبيق المصادقة ثم أدخل الأرقام الستة التي يعرضها.",
  "manual": "لا يمكنك المسح؟ أدخل هذا المفتاح في التطبيق:",
  "code": "رمز من 6 أرقام",
  "confirm": "تأكيد",
  "cancel": "إلغاء",
  "codesTitle": "رموز الاسترداد",
  "codesHint": "إن فقدت هاتفك، سجّل الدخول بأحد هذه الرموز بدلًا من الرمز. كل رمز يعمل مرة واحدة. احفظها في مكان آمن (مدير كلمات المرور)؛ لن تُعرض مرة أخرى.",
  "copy": "نسخ",
  "download": "تنزيل",
  "copied": "تم النسخ",
  "saved": "حفظتها",
  "codesLeft": "{n} رمز استرداد متبقٍ",
  "newCodes": "رموز استرداد جديدة",
  "newCodesHint": "أدخل رمزًا من تطبيقك. تتوقف رموز الاسترداد القديمة عن العمل.",
  "turnOff": "إيقاف",
  "turnOffHint": "أدخل كلمة المرور ورمزًا من تطبيقك.",
  "password": "كلمة المرور",
  "requiredBy": "مطلوب من {orgs}، لذا لا يمكن إيقافه.",
  "enabled": "التحقق بخطوتين مفعّل",
  "disabled": "التحقق بخطوتين غير مفعّل",
  "orgTitle": "اشتراط التحقق بخطوتين",
  "orgHint": "على كل أعضاء {org} استخدام التحقق بخطوتين. من لم يفعّله يمكنه فتح إعدادات حسابه فقط حتى يفعّله.",
  "orgNeedsYours": "فعّله لحسابك أولًا.",
  "orgOn": "أصبح التحقق بخطوتين مطلوبًا من الجميع",
  "orgOff": "أصبح التحقق بخطوتين اختياريًا",
  "requiredTitle": "تشترط {org} التحقق بخطوتين",
  "requiredBody": "فعّله الآن للمتابعة. يستغرق دقيقة مع تطبيق مصادقة على هاتفك.",
  "loginCodeTitle": "أدخل الرمز",
  "loginCodeHint": "افتح تطبيق المصادقة وأدخل الرمز المكوّن من 6 أرقام. فقدت هاتفك؟ أدخل أحد رموز الاسترداد.",
  "loginCodeLabel": "الرمز أو رمز الاسترداد",
  "verify": "تحقق",
  "backToPassword": "استخدام حساب آخر"
};
export default { en, ar };
